import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PaymentFailed = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Get error details from URL params
  const urlParams = new URLSearchParams(location.search);
  const error = urlParams.get("error");
  const message = urlParams.get("message");

  const handleRetryPayment = () => {
    navigate("/");
  };

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className='min-h-screen flex items-center justify-center bg-gray-50'>
      <div className='max-w-md w-full bg-white rounded-lg shadow-md p-6 text-center'>
        <div className='mb-6'>
          <div className='text-red-500 text-6xl mb-4'>✗</div>
        </div>

        <h2 className='text-2xl font-bold mb-4 text-red-600'>Payment Failed</h2>

        <div className='text-gray-600 mb-6'>
          <p className='mb-2'>
            {message || "Your payment could not be processed successfully."}
          </p>
          <p className='text-sm'>
            {error === "payment_failed" &&
              "This could be due to insufficient funds, network issues, or payment gateway problems."}
            {error === "verification_failed" &&
              "Payment verification failed. Please contact support if the amount was deducted."}
            {error === "timeout" &&
              "Payment timed out. Please check your bank account before retrying."}
          </p>
        </div>

        <div className='space-y-3'>
          <button
            onClick={handleRetryPayment}
            className='w-full px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors'
          >
            Try Payment Again
          </button>

          <button
            onClick={handleGoHome}
            className='w-full px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors'
          >
            Go to Home
          </button>
        </div>

        {/* <div className='mt-6 text-sm text-gray-500'>
          <p>Need help? Contact support:</p>
          <p>Email: support@dibru.work</p>
          <p>Phone: +91-XXX-XXXX</p>
        </div> */}
      </div>
    </div>
  );
};

export default PaymentFailed;
